import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Sparkle } from './Sparkle';
const highlights = ['15+ Jahre Sales-Erfahrung', 'Über 50 Mio. € Eigenumsatz im Sales', 'Internationale Sales-Teams auf 7- & 8-stellige Umsätze skaliert', 'Über 2.500 Frauen erfolgreich begleitet', 'Gründerin der Hot Sales Girls Community'];
export function About() {
  return <section id="about" className="relative w-full overflow-hidden bg-cream px-4 py-10 sm:px-6 sm:py-12" data-id="element-13" data-mp="33pf7tulujjku">
      <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-14" data-mp="3dh1gpkapp6kf" />
      <span aria-hidden="true" className="gold-glitter-extra" data-id="element-15" data-mp="3dhupsrx5885q" />
      <div className="relative z-10 mx-auto grid max-w-[1300px] items-center gap-8 md:grid-cols-2 md:gap-x-10 md:gap-y-8 lg:gap-14" data-id="element-16" data-mp="3hhldgmrdi861">
        <div className="md:col-start-1 md:col-end-3 md:row-start-1 lg:col-end-2" data-id="element-17" data-mp="3mjkgfvj7b32g">
        <span className="mb-4 block text-[11px] font-semibold uppercase tracking-[0.25em] text-hot-500" data-id="element-18" data-mp="3rhm1un43neh3">
          About Me
        </span>
        <div className="relative inline-block" data-id="element-19" data-mp="2lousd627mpet">
          <Sparkle className="animate-sparkle-delayed -right-4 -top-2 h-5 w-5 sm:-left-6 sm:right-auto sm:h-7 sm:w-7" data-id="element-20" data-mp="2gr2wy22cwl5v" />
          <h2 className="font-heading whitespace-nowrap text-[21px] font-extrabold uppercase leading-tight text-neutral-900 sm:text-4xl" data-id="element-21" data-mp="2cr2iihf9c9yt">
            Erfahre mehr über mich
          </h2>
        </div>

        <p className="mt-5 text-[15px] leading-relaxed text-neutral-600" data-id="element-22" data-mp="34gxaymyewfrp">
          Mit 18 startete ich im Door-to-Door-Vertrieb und in der Kaltakquise – ohne Netzwerk, dafür
          mit dem Willen, Sales wirklich von Grund auf zu lernen.
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-neutral-600" data-id="element-23" data-mp="2qqtwii5rxqct">
          Heute blicke ich auf über 15 Jahre Sales-Erfahrung und mehr als 50 Mio. € Eigenumsatz
          zurück und habe mit internationalen Unternehmen und Sales-Teams gearbeitet.
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-neutral-600" data-id="element-24" data-mp="3jd4s1eeix12r">
          Heute gebe ich genau dieses Wissen weiter und zeige Frauen, wie sie starke Sales-Skills
          aufbauen, selbstbewusst verkaufen und sich damit neue berufliche und finanzielle
          Möglichkeiten schaffen können.
        </p>
        </div>

        <div className="md:col-start-1 md:row-start-2 lg:self-start" data-id="element-25" data-mp="1elndj22gp28">
            <ul className="space-y-3 md:mt-0" data-id="element-26" data-mp="3jkqbbufairux">
              {highlights.map(item => <li key={item} className="flex items-start gap-3" data-id="element-27" data-mp="3jn312trai6ij">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center gold-icon-shiny rounded-full text-white" data-id="element-28" data-mp="3olecva15ar3e">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-29" data-mp="3amekbraihs1y" />
                  </span>
                  <span className="text-sm text-neutral-700" data-id="element-30" data-mp="3engn2i3n0m8o">{item}</span>
                </li>)}
            </ul>

            <Link to="/about-me" className="btn-gold-shiny mt-8 inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-31" data-mp="1cush40zlzkp7">
              Erfahre hier mehr über mich
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="2tc0yb4zsykl8" />
            </Link>
          </div>

          <div className="relative mx-auto w-full max-w-md md:col-start-2 md:row-start-2 md:max-w-[320px] lg:col-start-2 lg:row-start-1 lg:row-span-2 lg:max-w-none" data-id="element-33" data-mp="372w9inxrxdrz">
            <img src="https://cdn.magicpatterns.com/uploads/3jcUeFi2eMN74P6b8xwCr9/image.png" alt="Tina Xla" className="w-full rounded-[2rem] object-cover shadow-2xl" data-id="element-34" data-mp="3gzskr1f24e08" />

            <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="absolute -left-1 top-[20%] max-w-[112px] rounded-xl bg-white p-2.5 shadow-xl sm:-left-6 sm:top-[28%] sm:max-w-[180px] sm:rounded-2xl sm:p-5 md:max-w-[124px] md:p-3 lg:-left-10 lg:max-w-[180px] lg:p-5" data-id="element-35" data-mp="3pzp6au65gwr2">
              <span className="font-sans text-base font-bold tracking-tight text-hot-500 sm:text-3xl md:text-lg lg:text-3xl" data-id="element-36" data-mp="1x3leyq8nnnvp">
                2.500+
              </span>
              <p className="mt-0.5 text-[10px] leading-snug text-neutral-600 sm:mt-1 sm:text-sm md:text-[11px] lg:text-sm" data-id="element-37" data-mp="221ej7dqee7tc">
                Frauen begleitet
              </p>
            </motion.div>

            <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="absolute -right-1 top-[48%] max-w-[112px] rounded-xl bg-white p-2.5 shadow-xl sm:-right-6 sm:top-[58%] sm:max-w-[180px] sm:rounded-2xl sm:p-5 md:max-w-[124px] md:p-3 lg:-right-4 lg:max-w-[180px] lg:p-5" data-id="element-38" data-mp="1edmypmupeogz">
              <span className="font-sans text-base font-bold tracking-tight text-hot-500 sm:text-3xl md:text-lg lg:text-3xl" data-id="element-39" data-mp="vlb1feiwqddp">
                5,0
              </span>
              <p className="mt-0.5 text-[10px] leading-snug text-neutral-600 sm:mt-1 sm:text-sm md:text-[11px] lg:text-sm" data-id="element-40" data-mp="j5l3ipzahyb1">
                Google Bewertung
              </p>
            </motion.div>
          </div>
      </div>
    </section>;
}